var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['podium-pro', { 'hero-margin-top': _vm.applyHeroBannerBetaStyle }]},_vm._l((_vm.partners),function(partner,index){return _c(_vm.isPartnerRowZeta ? 'PodiumCardZeta' : 'PodiumCardDefault',_vm._b({key:index,tag:"component",attrs:{"partner":partner,"index":index}},'component',{ ..._vm.cardProps },false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }